import { IRequesterInfo } from '../../../../base/models'
import { ClientProxy } from '../../../../base/proxy/clientProxy'

export class CheckPreOrderAuthApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'order/PreOrderDealerAuth',
      requesterInfo,
    })
  }

  public async checkPreOrder(): Promise<boolean> {
    return await this.getAsync<boolean>()
  }
}
